import styled from 'styled-components';

const ListStyled = styled.ul.attrs({
  className: 'component__List',
})`
  display: block;
  list-style-type: none;
  margin-block-start: 0;
  margin-block-end: 0;
  margin-inline-start: 0;
  margin-inline-end: 0;
  padding-inline-start: 0;
`;

export default ListStyled;
